module.exports = __webpack_public_path__ + "img/5.7cdc3177.jpg";